<script>
export default {
  name: 'ModalOverlay',
};
</script>

<template>
  <portal to="modalBlur">
    <div class="modal">
      <slot></slot>
    </div>
  </portal>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.modal {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 11;
  width: 100vw;
  height: 100vh;
}

@media (max-width: $mobile) {
  .modal {
    height: 100%;
  }
}
</style>
